<template>
  <slot>
    <nav class="govuk-wizard-legend">
      <li v-for="value in steps" :key="value.Id" :data-slide-id="value.Id" class="govuk-wizard-legend-item" @click="navigateToStep(value)">
        {{value.Label}}
      </li>
    </nav>
  </slot>
</template>
<script lang="ts" src="@/library/builder/Wizard.ts"></script>
